export default {
  categories: 'Categories',
  category: 'Category',
  verbose_category: 'a category',
  select_categories: 'Select a category',
};
